export default {"src":"/_next/static/media/LeMans-Logo-small.a64f8502.svg","height":154,"width":308,"blurWidth":0,"blurHeight":0};